import moment from 'moment'

moment.locale('ja')

export default function formatDate(date: string | Date | undefined): string {
  return date ? moment(date).format('YYYY/MM/DD(dd) HH:mm') : ''
}
